






















































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import {
  FieldChildrenProp,
  GetReportsResponse
} from '@/services/hexabase/types';
import MasterSelectControl from '@/components/common/modules/MasterSelectControl.vue';
import SearchPanel from '@/components/common/modules/list/SearchPanel.vue';
import SearchList from '@/components/common/modules/list/SearchList.vue';
import { listPerPage, Messages } from '@/constants/util';
import hexabaseState from '@/store/hexabase';
import searchState from '@/store/search';
@Component({
  components: {
    MasterSelectControl,
    SearchPanel,
    SearchList
  }
})
export default class SelectSearch extends Vue {
  // ラベル名
  @Prop({ default: '' })
  private label?: string;
  // インプット(左辺)タイプ
  @Prop({ default: 'text' })
  private leftSideInputType?: string;
  // インプット(左辺)ネーム
  // form.tsやsearch.tsで本component使用時にprops.leftSideInputNameで
  // 指定したdisplay_idの値が左辺に表示されるようになる。
  @Prop({ default: '' })
  private leftSideInputName!: string;
  // インプット(左辺)内のdefault値
  @Prop({ default: '' })
  private value?: any;
  // インプット(左辺)内の文字数制限
  @Prop({ default: '' })
  private leftSideInputMaxlength?: string;
  // インプット(左辺)の表示・非表示
  @Prop({ default: true })
  private isLeftSideInputCodeVisible?: boolean;
  // インプット(左辺)の操作
  @Prop({ default: false })
  private isLeftSideInputDisabled?: boolean;
  // インプット(左辺)要素プレースホルダ
  @Prop({ default: '' })
  private isLeftSideInputPlaceholder?: string;
  // インプット(左辺)の専用状態
  @Prop({ default: false })
  private isLeftSideInputReadOnly?: boolean;
  // インプット(右辺)タイプ
  @Prop({ default: 'text' })
  private rightSideInputType?: string;
  // インプット(右辺)ネーム
  // form.tsやsearch.tsで本component使用時にprops.rightSideInputNameで
  // 指定したdisplay_idの値が右辺に表示されるようになる。
  @Prop({ default: '' })
  private rightSideInputName!: string;
  // インプット(右辺)内のdefault値
  @Prop({ default: '' })
  private rightSideDefaultValue?: string;
  // インプット(右辺)内の文字数制限
  @Prop({ default: '' })
  private rightSideInputMaxlength?: string;
  // インプット(右辺)の表示・非表示
  @Prop({ default: true })
  private isRightSideInputCodeVisible?: boolean;
  // インプット(右辺)の操作
  @Prop({ default: false })
  private isRightSideInputDisabled?: boolean;
  // インプット(右辺)要素プレースホルダ
  @Prop({ default: '' })
  private isRightSideInputPlaceholder?: string;
  // インプット(左辺)の読み取り専用状態
  @Prop({ default: false })
  private isRightSideInputReadOnly?: boolean;
  // ダイヤログ表示のタイトル
  @Prop({ default: '' })
  private dialogTitle?: string;
  // 領域外を押下した際の閉じる処理
  @Prop({ default: false })
  private isPersistent?: boolean;
  // 取得ボタンの表示・非表示
  @Prop({ default: true })
  private isBtnVisible?: boolean;
  // ラベルの表示・非表示
  @Prop({ default: true })
  private isShowLabel?: boolean;
  //参照元のデータベース項目ID
  @Prop({ default: '' })
  private masterId!: string;
  // テーブルに表示するカラム配列
  @Prop({ default: () => ([]) })
  private columns!: Array<any>;
  // テーブルに表示するデータ配列
  @Prop({ default: () => ([]) })
  private body!: Array<any>;
  // rulesの付与
  @Prop({ default: '' })
  private rules?: string;
  // 検索条件に表示するエレメント情報
  @Prop({ default: () => ([]) })
  private fieldData?: Array<FieldChildrenProp> ;
  // 検索のGridStyle値
  @Prop({ default: '' })
  private fieldCols?: string;
  // 検索要素のデータタイプ
  @Prop({ default: () => ({}) })
  private fieldTypes?: {[k: string]: string};
  //マスタモデル
  @Prop({ default: '' })
  private baseModel?: any;
  //マスタデータ
  @Prop({ default: () => ({}) })
  // マスタデータ関連格納プロパティ
  private masterData!: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } };
  // データテーブルに表示するデータリスト
  @Prop({ default: () => ([]) })
  private data?: [];
  // ステータス更新動作キャッチ用フラグ
  @Prop({ default: false })
  private flush!: boolean;
  // 主となるステータスのマスタトラン
  @Prop({ default: '' })
  private mainDsId!: string;
  //切り替え用マスタトラン
  @Prop({ default: '' })
  private changeMasterId!: string;
  //切り替え参照カラム
  @Prop({ default: '' })
  private recordId!: string;
  //マスタ定義
  @Prop({ default: () => ({}) })
  private selectSearchInfo: any;
  //検索条件連動向け設定
  @Prop()
  private narrowDownSelectOption?: Array<any>;
  //検索カラム幅
  @Prop()
  private SearchPanelColumnWidth: any;
  //検索結果クリック時遷移先情報
  @Prop({ default: '' })
  private clickButtonName?: string;
  //切り替え初期表示判定カラム
  @Prop({ default: '' })
  private defaultDisp?: string;
  // 検索条件で除外するステータス
  @Prop({ default: () => ([]) })
  private exclusionStatus?: string[];
  // 一覧内で遷移ボタンを表示するColumn
  @Prop({ default: () => ([]) })
  private buttonItems?: [];

  // ダイアログの表示制御値
  private dialogStatus = false;
  // api結果フラグ
  private apiResult = false;
  // インプット(左辺)内の値
  leftSideInputValue = '';
  // インプット(右辺)内の値
  rightSideInputValue = '';
  private bgColor = '';
  // 一覧表示部分に使用
  private fieldsData: any = {}
  //検索結果格納
  private apiResponseData: any = {};
  private colums: Array<{[k: string]: string | number}> = [];
  // ページネーション情報
  private page = {
    currentPage: 1,
    totalPage: 1,
    totalItem: 0,
    visible: 8,
    perPage: listPerPage
  };
  // アイテム取得時Param
  /* eslint-disable @typescript-eslint/camelcase */
  private payload = {
    conditions: [] as Array<{[key: string]: string | string[] | boolean}>,
    per_page: listPerPage,
    page: 1,
    use_display_id: true,
    include_links: true,
    include_lookups: true
  };
  // 各入力フィールド情報格納プロパティ
  private searchFieldsData: Array<FieldChildrenProp> = [];
  private searchFieldCols = '';
  private statusList: any = {};
  // アプリIDをセット
  private projectId = hexabaseState.applicationId;
  // dbID格納プロパティ
  private dataReportSelected = '';
  //検索項目
  private searchForm: any = {};
  //切り替え初期表示
  private itemId: any = {};
  // サービス種別物理名
  private serviceType = '';
  // 検索文言
  private dataTableText = Messages.dataTableText;

  /**
   * 初期値の設定
   */
  async mounted() {
    // ローディングをセット
    this.$store.commit("hexabase/setIsLoading", true);
    if (this.value) {
      const findData = this.body.find((v) => v.i_id === this.value.item_id);
      if (findData !== undefined) {
        this.leftSideInputValue = findData[this.masterId];
        this.rightSideInputValue = findData[this.rightSideInputName];
      }
    }
    if (this.rightSideDefaultValue) {
      this.rightSideInputName = this.rightSideDefaultValue;
    }
  }
  @Watch('value')
  watchValue() {
    if (this.value) {
      const findData = this.body.find((v) => v.i_id === this.value.item_id);
      if (findData !== undefined) {
        this.leftSideInputValue = findData[this.masterId];
        this.rightSideInputValue = findData[this.rightSideInputName];
      } else {
        this.leftSideInputValue = '';
        this.rightSideInputValue = '';
      }
    }
    if (this.rightSideDefaultValue) {
      this.rightSideInputName = this.rightSideDefaultValue;
    }
  }
  // 初期表示設定
  @Watch('masterData')
  async watchMasterData() {
    let itemRecord = this.masterData[this.changeMasterId!].body.find(v=>v[this.rightSideInputName] === this.defaultDisp);
    if (itemRecord == undefined) {
      itemRecord = this.masterData[this.changeMasterId!].body.find(v=>v[this.rightSideInputName] === '汎用');
    }
    //参照データレポート
    const dataReport = itemRecord!.data_report_id_for_project_search!;
    const searchForm = this.selectSearchInfo[itemRecord![this.recordId]][0].searchForm;
    const selectDispCol = this.selectSearchInfo[itemRecord![this.recordId]][0].selectDispCol;
    //データレポートの格納
    this.dataReportSelected = dataReport;
    this.searchForm = searchForm;
    // 切り替え初期表示設定
    this.serviceType = itemRecord!['service_type'];
    this.itemId = { item_id: itemRecord!.i_id };
    // 検索条件リセット
    this.searchFieldsData = [];
    await this.resetSearchField(
      dataReport,
      searchForm,
      this.baseModel,
      this.mainDsId,
      this.masterData
    );
    // 一覧カラム設定
    this.colums = this.baseModel.createColumns(selectDispCol, this.fieldsData.fields);
    this.colums.push();
    this.$store.commit("hexabase/setIsLoading", false);
  }

  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOperation
   * @return data - 名前と入力値
   */
  @Emit('inputOperation')
  public inputOperation(data: any) {
    this.leftSideInputValue = '';
    this.rightSideInputValue = '';
    this.bgColor = '';
    if (data !== '') {
      const findData = this.body.find((v) => v[this.masterId] === data.value);
      if (findData !== undefined) {
        this.leftSideInputValue = findData[this.masterId];
        this.rightSideInputValue = findData[this.rightSideInputName];
        data.value = findData.i_id;
      } else {
        // 一致するデータがなければ値をクリアする
        data.value = '';
      }
    }
    return 'selectData' in data ? {name: this.leftSideInputName, value: data.selectData.i_id } : data ;
  }
  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOperationRelay
   * @return data - 名前と入力値
   */
  public catchTableDataRelay(data: any) {
    this.inputOperation(data);
    this.dialogStatus = false;
    this.leftSideInputValue = data.selectData[this.masterId];
    this.rightSideInputValue = data.selectData[this.rightSideInputName];
    return data.selectData;
  }
  /**
   * 検索パネルにて「リセット」ボタン押下時
   * 内部プロパティの検索情報を消去する
   * @returns void 内部プロパティ消去
   */
  private resetSearchForm(): void {
    this.searchFieldsData = [];
    //検索条件リセット
    this.resetSearchField(this.dataReportSelected,this.searchForm, this.baseModel, this.mainDsId, this.masterData  );
  }
  getErr(errors: any) {
    if (errors && errors.length > 0) {
      this.bgColor = 'error';
    } else {
      this.bgColor = '';
    }
  }
  /**
   * 検索結果、ボタン押下時の各処理を記載
   * @param response - クリックしたボタンタイプ、インデックス、レコード情報
   * @return void - 内部プロパティ変更
   */
  private clickButton(response: { [k: string]: any }) {
    switch (response.buttonName) {
      case 'detail': {
        // 登録編集に遷移
        this.$router.push({ name: this.clickButtonName, params: { id: response.record.i_id }, query: { searchConditions: 'true' } });
        break;
      }
    }
  }
  /**
   * 子コンポーネントからEmitされる値を取得
   * 検索用Paramを作成し「searchConditions」に格納
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void} - コンソールに出力
   */
  @Emit('catchInput')
  private catchInput(response: any): void {
    if (this.narrowDownSelectOption !== undefined) {
      this.narrowDownSelectOption.forEach(element => {
        this.searchFieldsData = this.baseModel.getNarrowDownSelectOptin(
          this.searchFieldsData,
          this.masterData,
          response,
          element.keyDisplayId,
          element.targetDisplayId,
          element.keyDisplayName
        );
      });
    }
  }
  /**
   * 一覧表示するアイテムを取得する
   * @param {array} condition - 検索条件を指定する
   * @param {number} page - 検索オフセット情報
   * @returns {void} 各内部プロパティに情報セット
   */
  @Emit('getItems')
  async getItems(condition?: Array<{ [key: string]: string[] }>, page?: number) {
    if (condition !== undefined && condition.length > 0) {
      for (const key in searchState.searchCondition) {
        const findData = condition.find(recode => recode.id === searchState.searchCondition![key].id);
        if (!findData) {
          condition.push(searchState.searchCondition[key]);
        } else {
          const setConditionIndex = this.searchFieldsData.findIndex(field => field.display_id === searchState.searchCondition[key].id);
          if (setConditionIndex >= 0) {
            const componentType = this.searchFieldsData[setConditionIndex].component;
            switch (componentType) {
              case 'DatePickerRangeArea':
                if (searchState.searchCondition[key].search_value[0] && !findData.search_value[0]) {
                  findData.search_value[0] = searchState.searchCondition[key].search_value[0];
                }
                if (searchState.searchCondition[key].search_value[1] && !findData.search_value[1]) {
                  findData.search_value[1] = searchState.searchCondition[key].search_value[1];
                }
                break;
              default:
                break;
            }
          }
        }
      }
      searchState.setConditions(condition);
    }
    this.apiResult = false;
    if (condition !== undefined) {
      // conditionsに固定条件を付与するためconcatで参照渡しを回避する
      this.payload['conditions'] = condition.concat();
    }
    this.payload['page'] = page !== undefined ? page : 1 ;
    try{
      // ローディングをセット
      this.$store.commit("hexabase/setIsLoading", true);
      this.apiResponseData = await this.baseModel.getReports(this.projectId, this.dataReportSelected, this.payload);

      if (this.apiResponseData.errors !== undefined) {
        this.dataTableText = this.baseModel.getErrMessage('ITEMLIST', this.apiResponseData);
      } else if (this.apiResponseData.totalItems === 0) {
        this.dataTableText = this.baseModel.getMessage('ITEMLIST', 'NOT_FOUND');
      }
    } catch(e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit("hexabase/setIsLoading", false);
      this.apiResult = true;
    }
    // アイテム数等をセット
    if(this.apiResponseData.totalItems !== undefined) {
      this.page.totalItem = this.apiResponseData.totalItems, listPerPage;
      this.page.totalPage = this.baseModel.getTotalPage(this.apiResponseData.totalItems, listPerPage);
      this.page.currentPage = this.payload['page'];
      if (this.apiResponseData.report_results) {
        for (let i = 0; i < this.apiResponseData.report_results.length; i++) {
          if (this.apiResponseData.report_results[i].lookup_items.manager_id) {
            this.apiResponseData.report_results[i].manager_id = this.apiResponseData.report_results[i].lookup_items.manager_id.name
          }
        }
      }
    }
  }
  /**
   * サービス種別に合わせて検索条件を出しわける
   *
   */
  async masterSelectControlInput(event: any) {
    try {
      //検索条件をクリアする
      this.searchFieldsData = [];
      this.masterData = this.baseModel.getMaster();
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      const record = this.masterData[this.changeMasterId!].body.find(v => v.i_id === event.value);
      this.serviceType = record!['service_type'];
      //参照データレポート
      const dataReport = record!.data_report_id_for_project_search!;
      const searchForm = this.selectSearchInfo[record![this.recordId]][0].searchForm;
      const selectDispCol = this.selectSearchInfo[record![this.recordId]][0].selectDispCol;
      //データレポートの格納
      this.dataReportSelected = dataReport;
      this.searchForm = searchForm;
      // 検索条件リセット
      await this.resetSearchField(
        dataReport,
        searchForm,
        this.baseModel,
        this.mainDsId,
        this.masterData
      );
      this.searchFieldCols = `${this.SearchPanelColumnWidth}% `.repeat(
        100 / this.SearchPanelColumnWidth
      ); //検索フォームは表示を均等にするため固定
      // 一覧カラム設定
      this.colums = this.baseModel.createColumns(selectDispCol, this.fieldsData.fields);
      this.colums.push();
      this.apiResponseData = { report_fields: [], report_results: [], totalItems: 0 };
      // アイテム数等をセット
      this.page.totalItem = 0;
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit("hexabase/setIsLoading", false);
    }
  }
  /**
   * データレポート検索条件リセット
   * @param dataReportSelected 使用するデータレポート
   * @param searchForm 検索
   */
  async resetSearchField(
    dataReportSelected: string,
    searchForm: any,
    model: any,
    mainDsId: string,
    masterData: any
  ) {
    try {
      // ローディングをセット
      this.$store.commit("hexabase/setIsLoading", true);
      // 検索条件もリセット
      this.payload.conditions.splice(0);
      this.payload.page = 1;
      //検索条件をクリアする
      const [
        reportSearchConditions,
        statusList
      ] = await Promise.all([
        model.getReportSearchConditions(this.projectId, dataReportSelected),
        model.getStatusList(this.projectId, mainDsId)
      ]);

      // 除外ステータスが設定されている場合はリストから除外
      // データはデータレポートも設定で除外
      if (
        this.exclusionStatus !== undefined &&
        Array.isArray(this.exclusionStatus) &&
        statusList.length > 0 &&
        statusList[0].statuses !== undefined &&
        Array.isArray(statusList[0].statuses)
      ) {
        statusList[0].statuses = statusList[0].statuses.filter((status: {[k: string]: string}) => !this.exclusionStatus!.includes(status.text) );
      }
      // サービス種別で支払情報をフィルタリング
      const copyMasterData = this.baseModel.deepCopy(masterData);
      copyMasterData.m_payment_information.body = copyMasterData.m_payment_information.body.filter((v: { service_type_id: string; }) => v.service_type_id === this.serviceType);
      this.fieldsData = {fields: reportSearchConditions, field_layout: {}};
      this.searchFieldsData = await model.getSearchConfForProcess(this.fieldsData, copyMasterData, searchForm, statusList);
      this.searchFieldsData = model.setStatusBySelectProp(this.searchFieldsData, statusList[0].statuses);
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit("hexabase/setIsLoading", false);
    }
  }
  /**
   * ページネーションボタンが押下された際
   * 指定ページの情報を問い合わせに行く
   * @param {number} response - 子コンポーネントから渡ってきたページ番号
   * @returns void API問い合わせ
   */
  private pageNaviAction(response: number) {
    this.getItems(undefined, response);
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.baseModel.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit("hexabase/setIsError", true);
    this.$store.commit("hexabase/setErrorMessage", errorMessage);
  }
}
